import React, { useEffect, useState } from 'react';
import { useMerchants } from '../../store/merchnts/merchants-context';
import clsx from 'clsx';
import { IFees } from '../../store/merchnts/merchant-interfaces';
import { feeDataTypes } from '../../store/merchnts/merchant-context-variables';

interface IMerchantFeesTableRowProps {
	formEditStatus: boolean
	currentFee: IFees;
	onFeeUpdate: (currentFee: IFees, index: number) => void;
	index: number;
	setDefault?: boolean;
}

export const MerchantFeesTableRow = (props: IMerchantFeesTableRowProps):JSX.Element => {
	const { currentFee, formEditStatus, onFeeUpdate, index, setDefault } = props;
	const { merchantState: { defaultFees }} = useMerchants();
	const [fee, setFee] = useState(currentFee);

	const isPercentage = (feeName): boolean => feeName === feeDataTypes.PERCENTAGE || feeName === feeDataTypes.RISK_FEE;

	useEffect(() => {
		setFee(currentFee);
	}, [currentFee]);

	const handleFeeChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		const value = Math.abs(Number(e.target.value));
		setFee(prev => ({ ...prev, amount: value }));
		onFeeUpdate({ ...fee, amount: value }, index);
	};

	const handlePercentageChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		if (e.target.value) {
			let value = Math.abs(Number(e.target.value));
			if (value > 100) {
				value = value - (value - 100);
			}
			setFee(prev => ({ ...prev, amount: value }));
			onFeeUpdate({ ...fee, amount: value }, index);
		} else {
			setFee(prev => ({ ...prev, amount: 0 }));
			onFeeUpdate({ ...fee, amount: 0 }, index);
		}
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>, name: string): void =>
		(isPercentage(name)
			? handlePercentageChange(e)
			: handleFeeChange(e));

	const handleDefaultClick = (name): void => {
		const res = defaultFees?.find(fee => fee.name === name);
		setFee(prev => ({ ...prev, amount: res?.amount }));
		onFeeUpdate({ ...fee, amount: res?.amount }, index);
	};

	const handleMinFeeChange = (e): void => {
		const value = e.target.value === '' ? '' : Math.abs(Number(e.target.value));

		setFee(prev => ({ ...prev, minimumFeeAmount: value }));
		onFeeUpdate({ ...fee, minimumFeeAmount: value }, index);
	};


	return (
		<tr>
			<td className="w-150px">
				{fee?.name}
			</td>
			<td className="py-7">
				<div className={clsx('fee-input-container', formEditStatus && 'isEditBG')}>
					{
						!isPercentage(fee?.name) && (
							<div>
								$
							</div>
						)
					}
					<input
						type="number"
						className="number-input"
						step="1"
						lang="en"
						placeholder="0.00"
						value={fee?.amount ? fee?.amount : null}
						onChange={(e): void => handleChange(e, fee?.name)}
						disabled={!formEditStatus}
					/>
					<div>{!isPercentage(fee?.name) ? 'USD' : '%'}</div>
				</div>
			</td>
			<td className="py-7">
				<div className={clsx('fee-input-container', formEditStatus && 'isEditBG')}>
					<div>$</div>
					<input
						type="number"
						className="number-input"
						step="1"
						lang="en"
						placeholder="---"
						value={fee?.minimumFeeAmount}
						onChange={(e): void => handleMinFeeChange(e)}
					/>
					<div>USD</div>
				</div>
			</td>
			{
				setDefault && (
					<td>
						<span
							className={clsx('text-danger fw-bolder text-decoration-underline', formEditStatus ? 'cursor-pointer' : 'cursor-not-allowed')}
							onClick={(): void => formEditStatus && handleDefaultClick(fee?.name)}
						>

							Reset to default
						</span>
					</td>
				)
			}
		</tr>
	);
};
